import React from 'react';
import propTypes from 'prop-types';

import DetailTableInfo from '../Detail/DetailTable';
import FloorPlanImagesWidget from '../FloorPlanImagesWidget/FloorPlanImagesWidget';
import ResidenceView from '../ResidenceView/ResidenceView';
import VirtualTourDetail from '../VirtualTour/VirtualTourDetail';
import VideoDetail from '../Video/VideoDetail';
import FurnitureConfigurator from '../FurnitureConfigurator/FurnitureConfigurator';
import FinishCollection from '../FinishCollection/FinishCollection';
import PhotoGalleryDetail from '../PhotoGallery/PhotoGalleryDetail/PhotoGalleryDetail';
import FloorPlanFinancialPlans from './FloorPlanFinancialPlans';

import '../Detail/Detail.scss';

const FloorPlanDetailCore = ( { data } ) => {
  const {
    roomData,
    view,
    threeSixties,
    furnitureConfiguratorUrl,
    finishCollection,
    isSiteSee,
    video,
    photoGalleryImages,
    feePlanMap,
    hasFeePlanNames,
  } = data;

  return (
    <>
      <FloorPlanFinancialPlans
        hasFeePlanNames={hasFeePlanNames}
        planMap={feePlanMap}
        className="detailSection detailSection__displayFees"
      />

      <FloorPlanImagesWidget
        className="detailSection"
        data={data}
      />

      <DetailTableInfo
        id="dimensions-scroll"
        className="detailSection"
        tableInfo={roomData}
      />

      <ResidenceView
        data={view}
      />

      <PhotoGalleryDetail
        id="slideshow-scroll"
        uuid={null}
        images={photoGalleryImages}
        galleryClass="slideshow detailSection detailSection--gallery"
        imageClass="slideshowPhoto"
      />

      <VideoDetail
        hasId
        videoId={video?.videoId}
        service={video?.service}
        autoplay={false}
        className="detailSection"
      />

      <VirtualTourDetail
        id="tour-scroll"
        uuid={null}
        threeSixtiesData={threeSixties}
        className="detailSection detailSection--virtualTour"
      />

      <FurnitureConfigurator
        id="configurator-scroll"
        url={furnitureConfiguratorUrl}
        className="detailSection modalSection--sixteen9 modalSection--border"
      />

      <FinishCollection
        id="finishes-scroll"
        finishCollection={finishCollection}
        className="detailSection"
        isSiteSee={isSiteSee}
      />
    </>
  );
};

FloorPlanDetailCore.propTypes = {
  data: propTypes.object,
};

FloorPlanDetailCore.defaultProps = {
  data: {},
};

export default FloorPlanDetailCore;
